import { render } from "./ProductCarousel.vue?vue&type=template&id=58be746b&scoped=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"

import "./ProductCarousel.vue?vue&type=style&index=0&id=58be746b&scoped=true&lang=css"

import exportComponent from "/Volumes/Work/1Gate/1Gate/1gate_check_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58be746b"]])

export default __exports__